export enum MetricTypeEnum {
  VehicleECU = 'vehicle_ecu',
  VehicleABS = 'vehicle_abs',
  VehicleBCM = 'vehicle_bcm',
  VehicleTPMS = 'vehicle_tpms',
  VehicleENVIRONMENT = 'vehicle_environment',
}
